import React from "react";
import "./style.css";

const Input = (props) => {
	return (
		<div className="form-group">
			<label htmlFor="InputEmail">Subject</label>
			<input
				className="form-control"
				type={props.inputType}
				name={props.inputName}
				id={props.inputId}
				placeholder={props.inputPlaceHolder}
				value={props.inputValue}
				onChange={props.handleChange}
			/>
		</div>
	);
};

export default Input;
